import { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { Button } from "@mui/material";
import axios from "axios";
import moment from "moment";

export default function LogsModal({
  assetId,
  handleClose,
  userId,
  logsType,
  assetImage,
}) {
  const url = process.env.REACT_APP_URL;
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    if (logsType === "asset") {
      getLogsByAsset();
    } else if (logsType === "user") {
      getLogsByUser();
    }
  }, []);
  const getLogsByAsset = async () => {
    await axios
      .post(`${url}/assets/asset-logs`, { assetId: assetId })
      .then((res) => {
        setLogs(res.data.logs);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getLogsByUser = async () => {
    await axios
      .post(`${url}/users/user-logs`, { userId: userId })
      .then((res) => {
        setLogs(res.data.logs);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <Box className="asset-logs-modal">
      <section className="asset-logs-section">
        <h2>Asset Logs</h2>
        {logs && logs.length > 0 ? (
          <section className="log-table-container">
            <table className="log-table">
              <thead>
                <tr>
                  <th>Log</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {logs.map((l, i) => {
                  return (
                    <tr key={i}>
                      <td>{l.log}</td>
                      <td>{moment(l.date).format("HH:mm:ss DD//MM/YY")}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </section>
        ) : (
          <h3>No logs</h3>
        )}
        <Button
          variant="contained"
          color="error"
          onClick={() => handleClose(false)}
        >
          close
        </Button>
      </section>
    </Box>
  );
}
